export const translations = {
    en: {
        title: "F1 CALENDAR",
        subtitle: "TIMES IN YOUR ZONE:",
        round: "ROUND",
        sprint: "SPRINT",
        countdownFor: "COUNTDOWN FOR:",
        selectSession: "SELECT A SESSION",
        clickInstruction: "Click on a time to change the countdown",
        practice1: "Practice 1 (FP1)",
        practice2: "Practice 2 (FP2)",
        practice3: "Practice 3 (FP3)",
        sprintQualy: "Sprint Qualy (SQ)",
        sprintRace: "Sprint Race",
        qualifying: "Qualifying",
        grandPrix: "GRAND PRIX",
        calendar: "2026 CALENDAR",
        viewInfo: "VIEW INFO",
        pointsSystem: "F1 POINTS SYSTEM",
        raceFinished: "🏁 Finished 🏁",
        footer: "Page created by Marcelo Reyes",
        lastWinner: "Last Winner",
        days: "DAYS",
        hours: "HRS",
        minutes: "MIN",
        seconds: "SEC",
        teamsDrivers: "2026 TEAMS",
        team: "Team",
        driver1: "Driver 1",
        driver2: "Driver 2",
        createdBy: "CREATED BY MARCELO REYES",
        contactMe: "Contact Me",
        sendEmail: "Send Email",
        instagram: "Instagram",
        navCalendar: "Calendar",
        navPoints: "Points System",
        navTeams: "Teams",
        teamPrincipal: "Team Principal",
        launchDate: "Launch Date",
        navStandings: "Standings",
        generalStandings: "General Standings",
        standingsByRace: "Standings by Race",
        driverStandings: "Driver Standings",
        constructorStandings: "Constructor Standings",
        driver: "Driver",
        drivers: "Drivers",
        constructors: "Constructors",
        selectGP: "Select a Grand Prix",
        position: "Pos.",
        points: "PTS",
        noData: "No results available yet.",
        sprintResults: "Sprint Results",
        raceResults: "Race Results",
        suspended: "Suspended",
        suspendedGPNotice: "This Grand Prix has been suspended.",
        sessionsSuspended: "All sessions for this Grand Prix are suspended.",
        addToCalendar: "📅 Add to Calendar",
        addWeekendToCalendar: "⬇️ Download Weekend (.ics)",
        addFullCalendar: "⬇️ Download Full 2026 Season (.ics)",
        calendarConfirmFull: "This will open multiple tabs (one per session) to add the entire F1 2026 calendar to Google Calendar. Continue?",
        calendarConfirmWeekend: "This will open one tab per session for the full race weekend. Continue?",
        navSimulator: "Simulator",
        simulatorTitle: "F1 STANDINGS & SIMULATOR",
        simulatorSubtitle: "Simulate the remaining races of the 2026 season. Select the finishing positions to see standings update in real-time.",
        lockedGP: "Real Results (Locked)",
        pendingGP: "Pending Simulation",
        sprintResultsTitle: "Sprint Results (Top 8)",
        raceResultsTitle: "Race Results (Top 10)",
        mathematicalChamp: "🏆 MATHEMATICAL WORLD CHAMPION!",
        resetAll: "Reset Simulator",
        prefillRemaining: "Predict Remaining",
        clearGP: "Clear GP",
        selectDriver: "Select Driver"
    },
    es: {
        title: "CALENDARIO F1",
        subtitle: "HORARIOS EN TU ZONA:",
        round: "ROUND",
        sprint: "SPRINT",
        countdownFor: "CUENTA REGRESIVA PARA:",
        selectSession: "SELECCIONA UNA SESIÓN",
        clickInstruction: "Haz clic en un horario para cambiar el contador",
        practice1: "Práctica 1 (FP1)",
        practice2: "Práctica 2 (FP2)",
        practice3: "Práctica 3 (FP3)",
        sprintQualy: "Sprint Qualy (SQ)",
        sprintRace: "Carrera Sprint",
        qualifying: "Clasificación",
        grandPrix: "GRAN PREMIO",
        calendar: "CALENDARIO 2026",
        viewInfo: "VER INFO",
        pointsSystem: "SISTEMA DE PUNTOS F1",
        raceFinished: "🏁 Terminado 🏁",
        footer: "Página creada por Marcelo Reyes",
        lastWinner: "Último Ganador",
        days: "DÍAS",
        hours: "HORAS",
        minutes: "MIN",
        seconds: "SEG",
        teamsDrivers: "EQUIPOS 2026",
        team: "Escudería",
        driver1: "Piloto 1",
        driver2: "Piloto 2",
        createdBy: "CREADO POR MARCELO REYES",
        contactMe: "Contáctame",
        sendEmail: "Enviar Email",
        instagram: "Instagram",
        navCalendar: "Calendario",
        navPoints: "Sistema de Puntos",
        navTeams: "Equipos",
        teamPrincipal: "Director de Equipo",
        launchDate: "Fecha de Presentación",
        navStandings: "Clasificaciones",
        generalStandings: "Tabla de Posiciones General",
        standingsByRace: "Tabla de Posiciones por Carrera",
        driverStandings: "Clasificación de Pilotos",
        constructorStandings: "Clasificación de Escuderías",
        driver: "Piloto",
        drivers: "Pilotos",
        constructors: "Escuderías",
        selectGP: "Selecciona un Gran Premio",
        position: "Pos.",
        points: "PTS",
        noData: "No hay resultados disponibles aún.",
        sprintResults: "Resultados del Sprint",
        raceResults: "Resultados de la Carrera",
        suspended: "Suspendido",
        suspendedGPNotice: "Este Gran Premio ha sido suspendido.",
        sessionsSuspended: "Todas las sesiones de este Gran Premio han sido suspendidas.",
        addToCalendar: "📅 Agregar al calendario",
        addWeekendToCalendar: "⬇️ Descargar fin de semana (.ics)",
        addFullCalendar: "⬇️ Descargar temporada completa 2026 (.ics)",
        calendarConfirmFull: "Se abrirán varias pestañas (una por sesión) para agregar todo el calendario F1 2026 a Google Calendar. ¿Continuar?",
        calendarConfirmWeekend: "Se abrirá una pestaña por sesión para el fin de semana completo. ¿Continuar?",
        navSimulator: "Simulador",
        simulatorTitle: "SIMULADOR Y CLASIFICACIÓN F1",
        simulatorSubtitle: "Simula las carreras restantes de la temporada 2026. Selecciona las posiciones de llegada para ver las clasificaciones actualizarse en tiempo real.",
        lockedGP: "Resultados Reales (Bloqueado)",
        pendingGP: "Simulación Pendiente",
        sprintResultsTitle: "Resultados Sprint (Top 8)",
        raceResultsTitle: "Resultados Carrera (Top 10)",
        mathematicalChamp: "🏆 ¡CAMPEÓN DEL MUNDO MATEMÁTICO!",
        resetAll: "Reiniciar Simulador",
        prefillRemaining: "Predecir Restantes",
        clearGP: "Limpiar GP",
        selectDriver: "Seleccionar Piloto"
    },
    zh: {
        title: "F1 赛历",
        subtitle: "您所在时区的时间：",
        round: "第",
        sprint: "冲刺赛",
        countdownFor: "倒计时：",
        selectSession: "选择赛段",
        clickInstruction: "点击时间更改倒计时",
        practice1: "练习赛 1 (FP1)",
        practice2: "练习赛 2 (FP2)",
        practice3: "练习赛 3 (FP3)",
        sprintQualy: "冲刺排位赛 (SQ)",
        sprintRace: "冲刺赛",
        qualifying: "排位赛",
        grandPrix: "大奖赛",
        calendar: "2026 赛历",
        viewInfo: "查看信息",
        pointsSystem: "F1 积分系统",
        raceFinished: "🏁 已结束 🏁",
        footer: "页面由 Marcelo Reyes 创建",
        lastWinner: "上届冠军",
        days: "天",
        hours: "时",
        minutes: "分",
        seconds: "秒",
        teamsDrivers: "2026 车队",
        team: "车队",
        driver1: "车手 1",
        driver2: "车手 2",
        createdBy: "由 MARCELO REYES 创建",
        contactMe: "联系我",
        sendEmail: "发送邮件",
        instagram: "Instagram",
        navCalendar: "赛历",
        navPoints: "积分系统",
        navTeams: "车队",
        teamPrincipal: "车队领队",
        launchDate: "发布日期",
        navStandings: "积分榜",
        generalStandings: "总积分榜",
        standingsByRace: "单场比赛积分榜",
        driverStandings: "车手积分榜",
        constructorStandings: "车队积分榜",
        driver: "车手",
        drivers: "车手",
        constructors: "车队",
        selectGP: "选择大奖赛",
        position: "名次",
        points: "积分",
        noData: "暂无比赛结果。",
        sprintResults: "冲刺赛结果",
        raceResults: "大奖赛结果",
        suspended: "已取消",
        suspendedGPNotice: "该大奖赛已被取消。",
        sessionsSuspended: "该大奖赛的所有活动已被取消。",
        addToCalendar: "📅 添加到日历",
        addWeekendToCalendar: "⬇️ 下载赛周末 (.ics)",
        addFullCalendar: "⬇️ 下载2026完整赛季 (.ics)",
        calendarConfirmFull: "将打开多个标签页（每个赛段一个）以将整个F1 2026赛历添加到Google日历。是否继续？",
        calendarConfirmWeekend: "将为整个赛周末每个赛段打开一个标签页。是否继续？",
        navSimulator: "模拟器",
        simulatorTitle: "F1 模拟器与积分榜",
        simulatorSubtitle: "模拟 2026 赛季的剩余比赛。选择完赛位置以实时查看积分榜更新。",
        lockedGP: "真实结果 (已锁定)",
        pendingGP: "待模拟",
        sprintResultsTitle: "冲刺赛结果 (前 8 名)",
        raceResultsTitle: "大奖赛结果 (前 10 名)",
        mathematicalChamp: "🏆 数学意义上的世界冠军！",
        resetAll: "重置模拟器",
        prefillRemaining: "预测剩余比赛",
        clearGP: "清除本站",
        selectDriver: "选择车手"
    },
    ja: {
        title: "F1 カレンダー",
        subtitle: "あなたのタイムゾーン：",
        round: "第",
        sprint: "スプリント",
        countdownFor: "カウントダウン：",
        selectSession: "セッションを選択",
        clickInstruction: "時間をクリックしてカウントダウンを変更",
        practice1: "フリー走行 1 (FP1)",
        practice2: "フリー走行 2 (FP2)",
        practice3: "フリー走行 3 (FP3)",
        sprintQualy: "スプリント予選 (SQ)",
        sprintRace: "スプリントレース",
        qualifying: "予選",
        grandPrix: "グランプリ",
        calendar: "2026 カレンダー",
        viewInfo: "情報を見る",
        pointsSystem: "F1 ポイントシステム",
        raceFinished: "🏁 終了 🏁",
        footer: "ページ作成者: Marcelo Reyes",
        lastWinner: "前回優勝者",
        days: "日",
        hours: "時間",
        minutes: "分",
        seconds: "秒",
        teamsDrivers: "2026 チーム",
        team: "チーム",
        driver1: "ドライバー 1",
        driver2: "ドライバー 2",
        createdBy: "作成者: MARCELO REYES",
        contactMe: "お問い合わせ",
        sendEmail: "メールを送る",
        instagram: "Instagram",
        navCalendar: "カレンダー",
        navPoints: "ポイントシステム",
        navTeams: "チーム",
        teamPrincipal: "チーム代表",
        launchDate: "発表日",
        navStandings: "ランキング",
        generalStandings: "総合ランキング",
        standingsByRace: "レース別結果",
        driverStandings: "ドライバーランキング",
        constructorStandings: "コンストラクターランキング",
        driver: "ドライバー",
        drivers: "ドライバー",
        constructors: "コンストラクター",
        selectGP: "グランプリを選択",
        position: "順位",
        points: "ポイント",
        noData: "結果はまだありません。",
        sprintResults: "スプリント結果",
        raceResults: "レース結果",
        suspended: "中止",
        suspendedGPNotice: "このグランプリは中止されました。",
        sessionsSuspended: "このグランプリのすべてのセッションが中止されました。",
        addToCalendar: "📅 カレンダーに追加",
        addWeekendToCalendar: "⬇️ 週末をダウンロード (.ics)",
        addFullCalendar: "⬇️ 2026シーズン全体をダウンロード (.ics)",
        calendarConfirmFull: "F1 2026カレンダー全体をGoogleカレンダーに追加するために複数のタブを開きます。続けますか？",
        calendarConfirmWeekend: "レース週末の各セッションごとにタブを開きます。続けますか？",
        navSimulator: "シミュレーター",
        simulatorTitle: "F1 シミュレーター & 順位表",
        simulatorSubtitle: "2026年シーズンの残りのレースをシミュレートします。完走順位を選択して、順位表がリアルタイムで更新されるのを確認してください。",
        lockedGP: "実際のレース結果 (ロック済)",
        pendingGP: "シミュレーション保留中",
        sprintResultsTitle: "スプリント結果 (トップ 8)",
        raceResultsTitle: "レース結果 (トップ 10)",
        mathematicalChamp: "🏆 数学的なワールドチャンピオン！",
        resetAll: "シミュレーターをリセット",
        prefillRemaining: "残りを予測",
        clearGP: "GPをクリア",
        selectDriver: "ドライバーを選択"
    },
    ar: {
        title: "تقويم الفورمولا 1",
        subtitle: "الأوقات في منطقتك:",
        round: "الجولة",
        sprint: "سباق السرعة",
        countdownFor: "العد التنازلي لـ:",
        selectSession: "اختر جلسة",
        clickInstruction: "انقر على الوقت لتغيير العد التنازلي",
        practice1: "التجربة 1 (FP1)",
        practice2: "التجربة 2 (FP2)",
        practice3: "التجربة 3 (FP3)",
        sprintQualy: "تصفيات السرعة (SQ)",
        sprintRace: "سباق السرعة",
        qualifying: "التصفيات",
        grandPrix: "الجائزة الكبرى",
        calendar: "تقويم 2026",
        viewInfo: "عرض المعلومات",
        pointsSystem: "نظام نقاط F1",
        raceFinished: "🏁 انتهى 🏁",
        footer: "الصفحة من إنشاء Marcelo Reyes",
        lastWinner: "الفائز الأخير",
        days: "أيام",
        hours: "ساعات",
        minutes: "دقائق",
        seconds: "ثواني",
        teamsDrivers: "فرق 2026",
        team: "الفريق",
        driver1: "السائق 1",
        driver2: "السائق 2",
        createdBy: "أنشأها MARCELO REYES",
        contactMe: "اتصل بي",
        sendEmail: "إرسال بريد إلكتروني",
        instagram: "Instagram",
        navCalendar: "التقويم",
        navPoints: "نظام النقاط",
        navTeams: "الفرق",
        teamPrincipal: "مدير الفريق",
        launchDate: "تاريخ الإطلاق",
        navStandings: "الترتيب",
        generalStandings: "جدول الترتيب العام",
        standingsByRace: "الترتيب حسب السباق",
        driverStandings: "ترتيب السائقين",
        constructorStandings: "ترتيب الصانعين",
        driver: "السائق",
        drivers: "السائقين",
        constructors: "الصانعين",
        selectGP: "اختر جائزة كبرى",
        position: "المركز",
        points: "النقاط",
        noData: "لا توجد نتائج متاحة بعد.",
        sprintResults: "نتائج سباق السرعة",
        raceResults: "نتائج السباق الرئيسية",
        suspended: "معلق",
        suspendedGPNotice: "لقد تم تعليق هذا السباق الكبرى.",
        sessionsSuspended: "تم تعليق جميع الجلسات لهذا السباق الكبرى.",
        addToCalendar: "📅 أضف إلى التقويم",
        addWeekendToCalendar: "⬇️ تنزيل عطلة نهاية الأسبوع (.ics)",
        addFullCalendar: "⬇️ تنزيل الموسم كاملاً 2026 (.ics)",
        calendarConfirmFull: "سيتم فتح علامات تبويب متعددة (واحدة لكل جلسة) لإضافة تقويم F1 2026 بالكامل إلى تقويم Google. هل تريد المتابعة؟",
        calendarConfirmWeekend: "سيتم فتح علامة تبويب لكل جلسة لعطلة نهاية الأسبوع. هل تريد المتابعة؟",
        navSimulator: "المحاكي",
        simulatorTitle: "محاكي وترتيب إف 1",
        simulatorSubtitle: "قم بمحاكاة السباقات المتبقية من موسم 2026. حدد مراكز الوصول لرؤية جدول الترتيب يتحدث في الوقت الفعلي.",
        lockedGP: "النتائج الحقيقية (مغلق)",
        pendingGP: "محاكاة معلقة",
        sprintResultsTitle: "نتائج سباق السرعة (أفضل 8)",
        raceResultsTitle: "نتائج السباق الرئيسية (أفضل 10)",
        mathematicalChamp: "🏆 بطل العالم رياضياً!",
        resetAll: "إعادة ضبط المحاكي",
        prefillRemaining: "توقع المتبقي",
        clearGP: "مسح الجولة",
        selectDriver: "اختر السائق"
    },
    fr: {
        title: "CALENDRIER F1",
        subtitle: "HORAIRES DANS VOTRE ZONE:",
        round: "MANCHE",
        sprint: "SPRINT",
        countdownFor: "COMPTE À REBOURS POUR:",
        selectSession: "SÉLECTIONNER UNE SESSION",
        clickInstruction: "Cliquez sur un horaire pour changer le compte à rebours",
        practice1: "Essais Libres 1 (FP1)",
        practice2: "Essais Libres 2 (FP2)",
        practice3: "Essais Libres 3 (FP3)",
        sprintQualy: "Qualifications Sprint (SQ)",
        sprintRace: "Course Sprint",
        qualifying: "Qualifications",
        grandPrix: "GRAND PRIX",
        calendar: "CALENDRIER 2026",
        viewInfo: "VOIR INFO",
        pointsSystem: "SYSTÈME DE POINTS F1",
        raceFinished: "🏁 Terminé 🏁",
        footer: "Page créée par Marcelo Reyes",
        lastWinner: "Dernier Vainqueur",
        days: "JOURS",
        hours: "HEURES",
        minutes: "MIN",
        seconds: "SEC",
        teamsDrivers: "ÉQUIPES 2026",
        team: "Équipe",
        driver1: "Pilote 1",
        driver2: "Pilote 2",
        createdBy: "CRÉÉ PAR MARCELO REYES",
        contactMe: "Contactez-moi",
        sendEmail: "Envoyer un Email",
        instagram: "Instagram",
        navCalendar: "Calendrier",
        navPoints: "Système de Points",
        navTeams: "Équipes",
        teamPrincipal: "Directeur d'équipe",
        launchDate: "Date de Présentation",
        navStandings: "Classements",
        generalStandings: "Classement Général",
        standingsByRace: "Classement par Course",
        driverStandings: "Classement des Pilotes",
        constructorStandings: "Classement des Constructeurs",
        driver: "Pilote",
        drivers: "Pilotes",
        constructors: "Constructeurs",
        selectGP: "Sélectionner un Grand Prix",
        position: "Pos.",
        points: "PTS",
        noData: "Aucun résultat disponible pour le moment.",
        sprintResults: "Résultats du Sprint",
        raceResults: "Résultats de la Course",
        suspended: "Suspendu",
        suspendedGPNotice: "Ce Grand Prix a été suspendu.",
        sessionsSuspended: "Toutes les sessions de ce Grand Prix sont suspendues.",
        addToCalendar: "📅 Ajouter au calendrier",
        addWeekendToCalendar: "⬇️ Télécharger le week-end (.ics)",
        addFullCalendar: "⬇️ Télécharger la saison 2026 (.ics)",
        calendarConfirmFull: "Plusieurs onglets vont s'ouvrir (un par session) pour ajouter tout le calendrier F1 2026 à Google Agenda. Continuer?",
        calendarConfirmWeekend: "Un onglet par session sera ouvert pour le week-end complet. Continuer?",
        navSimulator: "Simulateur",
        simulatorTitle: "SIMULATEUR & CLASSEMENTS F1",
        simulatorSubtitle: "Simulez les courses restantes de la saison 2026. Sélectionnez les positions d'arrivée pour voir les classements mis à jour en temps réel.",
        lockedGP: "Résultats Réels (Verrouillés)",
        pendingGP: "Simulation en Attente",
        sprintResultsTitle: "Résultats du Sprint (Top 8)",
        raceResultsTitle: "Résultats de la Course (Top 10)",
        mathematicalChamp: "🏆 CHAMPION DU MONDE MATHÉMATIQUE !",
        resetAll: "Réinitialiser le Simulateur",
        prefillRemaining: "Prédire le Reste",
        clearGP: "Effacer GP",
        selectDriver: "Sélectionner Pilote"
    },
    it: {
        title: "CALENDARIO F1",
        subtitle: "ORARI NELLA TUA ZONA:",
        round: "ROUND",
        sprint: "SPRINT",
        countdownFor: "CONTO ALLA ROVESCIA PER:",
        selectSession: "SELEZIONA UNA SESSIONE",
        clickInstruction: "Clicca su un orario per cambiare il conto alla rovescia",
        practice1: "Prove Libere 1 (FP1)",
        practice2: "Prove Libere 2 (FP2)",
        practice3: "Prove Libere 3 (FP3)",
        sprintQualy: "Qualifiche Sprint (SQ)",
        sprintRace: "Gara Sprint",
        qualifying: "Qualifiche",
        grandPrix: "GRAN PREMIO",
        calendar: "CALENDARIO 2026",
        viewInfo: "VEDI INFO",
        pointsSystem: "SISTEMA PUNTI F1",
        raceFinished: "🏁 Terminato 🏁",
        footer: "Pagina creata da Marcelo Reyes",
        lastWinner: "Ultimo Vincitore",
        days: "GIORNI",
        hours: "ORE",
        minutes: "MIN",
        seconds: "SEC",
        teamsDrivers: "TEAM 2026",
        team: "Team",
        driver1: "Pilota 1",
        driver2: "Pilota 2",
        createdBy: "CREATO DA MARCELO REYES",
        contactMe: "Contattami",
        sendEmail: "Invia Email",
        instagram: "Instagram",
        navCalendar: "Calendario",
        navPoints: "Sistema Punti",
        navTeams: "Team",
        teamPrincipal: "Team Principal",
        launchDate: "Data di Presentazione",
        navStandings: "Classifiche",
        generalStandings: "Classifica Generale",
        standingsByRace: "Classifica per Gara",
        driverStandings: "Classifica Piloti",
        constructorStandings: "Classifica Costruttori",
        driver: "Pilota",
        drivers: "Piloti",
        constructors: "Costruttori",
        selectGP: "Seleziona un Gran Premio",
        position: "Pos.",
        points: "PT",
        noData: "Nessun risultato ancora disponibile.",
        sprintResults: "Risultati Sprint",
        raceResults: "Risultati Gara",
        suspended: "Sospeso",
        suspendedGPNotice: "Questo Gran Premio è stato sospeso.",
        sessionsSuspended: "Tutte le sessioni di questo Gran Premio sono sospese.",
        addToCalendar: "📅 Aggiungi al calendario",
        addWeekendToCalendar: "⬇️ Scarica il weekend (.ics)",
        addFullCalendar: "⬇️ Scarica la stagione 2026 (.ics)",
        calendarConfirmFull: "Si apriranno più schede (una per sessione) per aggiungere l'intero calendario F1 2026 a Google Calendar. Continuare?",
        calendarConfirmWeekend: "Si aprirà una scheda per ogni sessione del weekend di gara. Continuare?",
        navSimulator: "Simulatore",
        simulatorTitle: "SIMULATORE E CLASSIFICHE F1",
        simulatorSubtitle: "Simula le gare rimanenti della stagione 2026. Seleziona le posizioni di arrivo per vedere le classifiche aggiornarsi in tempo reale.",
        lockedGP: "Risultati Reali (Bloccato)",
        pendingGP: "Simulazione in Sospeso",
        sprintResultsTitle: "Risultati Sprint (Top 8)",
        raceResultsTitle: "Risultati Gara (Top 10)",
        mathematicalChamp: "🏆 CAMPIONE DEL MONDO MATEMATICO!",
        resetAll: "Reimposta Simulatore",
        prefillRemaining: "Predici Rimanenti",
        clearGP: "Cancella GP",
        selectDriver: "Seleziona Pilota"
    },
    nl: {
        title: "F1 KALENDER",
        subtitle: "TIJDEN IN UW ZONE:",
        round: "RONDE",
        sprint: "SPRINT",
        countdownFor: "AFTELLEN VOOR:",
        selectSession: "SELECTEER EEN SESSIE",
        clickInstruction: "Klik op een tijd om de aftelling te wijzigen",
        practice1: "Vrije Training 1 (FP1)",
        practice2: "Vrije Training 2 (FP2)",
        practice3: "Vrije Training 3 (FP3)",
        sprintQualy: "Sprint Kwalificatie (SQ)",
        sprintRace: "Sprint Race",
        qualifying: "Kwalificatie",
        grandPrix: "GRAND PRIX",
        calendar: "KALENDER 2026",
        viewInfo: "BEKIJK INFO",
        pointsSystem: "F1 PUNTENSYSTEEM",
        raceFinished: "🏁 Afgelopen 🏁",
        footer: "Pagina gemaakt door Marcelo Reyes",
        lastWinner: "Laatste Winnaar",
        days: "DAGEN",
        hours: "UREN",
        minutes: "MIN",
        seconds: "SEC",
        teamsDrivers: "TEAMS 2026",
        team: "Team",
        driver1: "Coureur 1",
        driver2: "Coureur 2",
        createdBy: "GEMAAKT DOOR MARCELO REYES",
        contactMe: "Neem contact op",
        sendEmail: "Stuur Email",
        instagram: "Instagram",
        navCalendar: "Kalender",
        navPoints: "Puntensysteem",
        navTeams: "Teams",
        teamPrincipal: "Teambaas",
        launchDate: "Lanceringsdatum",
        navStandings: "Klassementen",
        generalStandings: "Algemeen Klassement",
        standingsByRace: "Klassement per Race",
        driverStandings: "Coureursklassement",
        constructorStandings: "Constructeursklassement",
        driver: "Coureur",
        drivers: "Coureurs",
        constructors: "Constructeurs",
        selectGP: "Selecteer een Grand Prix",
        position: "Pos.",
        points: "PTS",
        noData: "Nog geen resultaten beschikbaar.",
        sprintResults: "Sprint Uitslag",
        raceResults: "Race Uitslag",
        suspended: "Geschorst",
        suspendedGPNotice: "Deze Grand Prix is geschorst.",
        sessionsSuspended: "Alle sessies voor deze Grand Prix zijn geschorst.",
        addToCalendar: "📅 Toevoegen aan agenda",
        addWeekendToCalendar: "⬇️ Weekend downloaden (.ics)",
        addFullCalendar: "⬇️ Volledig seizoen 2026 downloaden (.ics)",
        calendarConfirmFull: "Er worden meerdere tabbladen geopend (één per sessie) om de volledige F1 2026 agenda toe te voegen aan Google Agenda. Doorgaan?",
        calendarConfirmWeekend: "Er wordt één tabblad per sessie geopend voor het volledige raceweekend. Doorgaan?",
        navSimulator: "Simulator",
        simulatorTitle: "F1-SIMULATOR & STANDEN",
        simulatorSubtitle: "Simuleer de resterende races van het seizoen 2026. Selecteer de finishposities om de klassementen in realtime te zien bijwerken.",
        lockedGP: "Echte Resultaten (Vergrendeld)",
        pendingGP: "Simulatie In Afwachting",
        sprintResultsTitle: "Sprint Uitslag (Top 8)",
        raceResultsTitle: "Race Uitslag (Top 10)",
        mathematicalChamp: "🏆 MATHEMATISCH WERELDKAMPIOEN!",
        resetAll: "Simulator Resetten",
        prefillRemaining: "Voorspel Resterende",
        clearGP: "GP Wissen",
        selectDriver: "Selecteer Coureur"
    },
    hu: {
        title: "F1 NAPTÁR",
        subtitle: "IDŐPONTOK AZ ÖN ZÓNÁJÁBAN:",
        round: "FORDULÓ",
        sprint: "SPRINT",
        countdownFor: "VISSZASZÁMLÁLÁS:",
        selectSession: "VÁLASSZON SZAKASZT",
        clickInstruction: "Kattintson egy időpontra a visszaszámlálás megváltoztatásához",
        practice1: "Szabadedzés 1 (FP1)",
        practice2: "Szabadedzés 2 (FP2)",
        practice3: "Szabadedzés 3 (FP3)",
        sprintQualy: "Sprint Időmérő (SQ)",
        sprintRace: "Sprint Verseny",
        qualifying: "Időmérő",
        grandPrix: "NAGYDÍJ",
        calendar: "2026 NAPTÁR",
        viewInfo: "INFO MEGTEKINTÉSE",
        pointsSystem: "F1 PONTRENDSZER",
        raceFinished: "🏁 Befejeződött 🏁",
        footer: "Oldal készítője: Marcelo Reyes",
        lastWinner: "Utolsó Győztes",
        days: "NAP",
        hours: "ÓRA",
        minutes: "PERC",
        seconds: "MP",
        teamsDrivers: "CSAPATOK 2026",
        team: "Csapat",
        driver1: "Versenyző 1",
        driver2: "Versenyző 2",
        createdBy: "KÉSZÍTETTE: MARCELO REYES",
        contactMe: "Lépjen kapcsolatba",
        sendEmail: "Email küldése",
        instagram: "Instagram",
        navCalendar: "Naptár",
        navPoints: "Pontrendszer",
        navTeams: "Csapatok",
        teamPrincipal: "Csapatfőnök",
        launchDate: "Bemutató Dátuma",
        navStandings: "Pontverseny",
        generalStandings: "Összetett Pontverseny",
        standingsByRace: "Futamonkénti Eredmények",
        driverStandings: "Egyéni Pontverseny",
        constructorStandings: "Konstruktőri Pontverseny",
        driver: "Pilóta",
        drivers: "Pilóták",
        constructors: "Konstruktőrök",
        selectGP: "Válasszon Nagydíjat",
        position: "Hely.",
        points: "Pont",
        noData: "Még nincsenek eredmények.",
        sprintResults: "Sprint Eredmények",
        raceResults: "Verseny Eredmények",
        suspended: "Felfüggesztve",
        suspendedGPNotice: "Ezt a Nagydíjat felfüggesztették.",
        sessionsSuspended: "A Nagydíj összes futama felfüggesztésre került.",
        addToCalendar: "📅 Hozzáadás a naptárhoz",
        addWeekendToCalendar: "⬇️ Hétvége letöltése (.ics)",
        addFullCalendar: "⬇️ Teljes 2026 szezon letöltése (.ics)",
        calendarConfirmFull: "Több lap nyílik meg (szakaszonként egy) az F1 2026 teljes naptár Google Naptárhoz adásához. Folytatod?",
        calendarConfirmWeekend: "Versenyhétvégénként egy lap nyílik meg minden szakaszhoz. Folytatod?",
        navSimulator: "Szimulátor",
        simulatorTitle: "F1 SZIMULÁTOR ÉS ÁLLÁS",
        simulatorSubtitle: "Szimuláld a 2026-os szezon hátralévő futamait. Válaszd ki a befutó helyezéseket, hogy valós időben lásd a pontverseny frissülését.",
        lockedGP: "Valós Eredmények (Zárolva)",
        pendingGP: "Szimulációra Vár",
        sprintResultsTitle: "Sprint Eredmények (Top 8)",
        raceResultsTitle: "Futam Eredmények (Top 10)",
        mathematicalChamp: "🏆 MATEMATIKAILAG VILÁGBAJNOK!",
        resetAll: "Szimulátor Alaphelyzetbe",
        prefillRemaining: "Hátralévők Megjósolása",
        clearGP: "GP Törlése",
        selectDriver: "Pilóta Kiválasztása"
    },
    pt: {
        title: "CALENDÁRIO F1",
        subtitle: "HORÁRIOS NA SUA ZONA:",
        round: "ETAPA",
        sprint: "SPRINT",
        countdownFor: "CONTAGEM REGRESSIVA PARA:",
        selectSession: "SELECIONE UMA SESSÃO",
        clickInstruction: "Clique em um horário para mudar a contagem",
        practice1: "Treino Livre 1 (FP1)",
        practice2: "Treino Livre 2 (FP2)",
        practice3: "Treino Livre 3 (FP3)",
        sprintQualy: "Classificação Sprint (SQ)",
        sprintRace: "Corrida Sprint",
        qualifying: "Classificação",
        grandPrix: "GRANDE PRÊMIO",
        calendar: "CALENDÁRIO 2026",
        viewInfo: "VER INFO",
        pointsSystem: "SISTEMA DE PUNTOS F1",
        raceFinished: "🏁 Terminado 🏁",
        footer: "Página criada por Marcelo Reyes",
        lastWinner: "Último Vencedor",
        days: "DIAS",
        hours: "HORAS",
        minutes: "MIN",
        seconds: "SEG",
        teamsDrivers: "EQUIPES 2026",
        team: "Equipe",
        driver1: "Piloto 1",
        driver2: "Piloto 2",
        createdBy: "CRIADO POR MARCELO REYES",
        contactMe: "Entre em contato",
        sendEmail: "Enviar Email",
        instagram: "Instagram",
        navCalendar: "Calendário",
        navPoints: "Sistema de Pontos",
        navTeams: "Equipes",
        teamPrincipal: "Chefe de Equipe",
        launchDate: "Data de Lançamento",
        navStandings: "Classificações",
        generalStandings: "Tabela de Classificação Geral",
        standingsByRace: "Tabela de Classificação por Corrida",
        driverStandings: "Classificação de Pilotos",
        constructorStandings: "Classificação de Construtores",
        driver: "Piloto",
        drivers: "Pilotos",
        constructors: "Construtores",
        selectGP: "Selecione um Grande Prêmio",
        position: "Pos.",
        points: "PTS",
        noData: "Nenhum resultado disponível ainda.",
        sprintResults: "Resultados do Sprint",
        raceResults: "Resultados da Corrida",
        suspended: "Suspenso",
        suspendedGPNotice: "Este Grande Prêmio foi suspenso.",
        sessionsSuspended: "Todas as sessões deste Grande Prêmio foram suspensas.",
        addToCalendar: "📅 Adicionar ao calendário",
        addWeekendToCalendar: "⬇️ Baixar fim de semana (.ics)",
        addFullCalendar: "⬇️ Baixar temporada completa 2026 (.ics)",
        calendarConfirmFull: "Várias abas serão abertas (uma por sessão) para adicionar todo o calendário F1 2026 ao Google Agenda. Continuar?",
        calendarConfirmWeekend: "Uma aba por sessão será aberta para o fim de semana completo. Continuar?",
        navSimulator: "Simulador",
        simulatorTitle: "SIMULADOR E CLASSIFICAÇÕES F1",
        simulatorSubtitle: "Simule as corridas restantes da temporada de 2026. Selecione as posições de chegada para ver a classificação atualizada em tempo real.",
        lockedGP: "Resultados Reales (Bloqueado)",
        pendingGP: "Simulação Pendente",
        sprintResultsTitle: "Resultados do Sprint (Top 8)",
        raceResultsTitle: "Resultados da Corrida (Top 10)",
        mathematicalChamp: "🏆 CAMPEÃO DO MUNDO MATEMÁTICO!",
        resetAll: "Reiniciar Simulador",
        prefillRemaining: "Prever Restantes",
        clearGP: "Limpar GP",
        selectDriver: "Selecionar Piloto"
    },
    de: {
        title: "F1-KALENDER",
        subtitle: "ZEITEN IN IHRER ZEITZONE:",
        round: "RUNDE",
        sprint: "SPRINT",
        countdownFor: "COUNTDOWN FÜR:",
        selectSession: "SESSION AUSWÄHLEN",
        clickInstruction: "Klicken Sie auf eine Uhrzeit, um den Countdown zu ändern",
        practice1: "1. Freies Training (FP1)",
        practice2: "2. Freies Training (FP2)",
        practice3: "3. Freies Training (FP3)",
        sprintQualy: "Sprint-Qualifikation (SQ)",
        sprintRace: "Sprintrennen",
        qualifying: "Qualifying",
        grandPrix: "GROSSER PREIS",
        calendar: "KALENDER 2026",
        viewInfo: "INFO ANZEIGEN",
        pointsSystem: "F1-PUNKTE-SYSTEM",
        raceFinished: "🏁 Beendet 🏁",
        footer: "Seite erstellt von Marcelo Reyes",
        lastWinner: "Letzter Sieger",
        days: "TAGE",
        hours: "STD",
        minutes: "MIN",
        seconds: "SEK",
        teamsDrivers: "TEAMS 2026",
        team: "Team",
        driver1: "Fahrer 1",
        driver2: "Fahrer 2",
        createdBy: "ERSTELLT VON MARCELO REYES",
        contactMe: "Kontaktieren Sie mich",
        sendEmail: "E-Mail senden",
        instagram: "Instagram",
        navCalendar: "Kalender",
        navPoints: "Punktesystem",
        navTeams: "Teams",
        teamPrincipal: "Teamchef",
        launchDate: "Präsentationsdatum",
        navStandings: "WM-Stand",
        generalStandings: "Gesamtwertung",
        standingsByRace: "Ergebnisse nach Rennen",
        driverStandings: "Fahrerwertung",
        constructorStandings: "Konstrukteurswertung",
        driver: "Fahrer",
        drivers: "Fahrer",
        constructors: "Konstrukteure",
        selectGP: "Wählen Sie einen Großen Preis",
        position: "Pos.",
        points: "PKT",
        noData: "Noch keine Ergebnisse verfügbar.",
        sprintResults: "Sprint-Ergebnisse",
        raceResults: "Rennen-Ergebnisse",
        suspended: "Ausgesetzt",
        suspendedGPNotice: "Dieser Große Preis wurde ausgesetzt.",
        sessionsSuspended: "Alle Sessions für diesen Großen Preis wurden ausgesetzt.",
        addToCalendar: "📅 Zum Kalender hinzufügen",
        addWeekendToCalendar: "⬇️ Wochenende herunterladen (.ics)",
        addFullCalendar: "⬇️ Komplette Saison 2026 herunterladen (.ics)",
        calendarConfirmFull: "Dadurch werden mehrere Tabs geöffnet (einer pro Session), um den gesamten F1-Kalender 2026 zu Google Kalender hinzuzufügen. Fortfahren?",
        calendarConfirmWeekend: "Dadurch wird ein Tab pro Session for das gesamte Rennwochenende geöffnet. Fortfahren?",
        navSimulator: "Simulator",
        simulatorTitle: "F1-SIMULATOR & WM-STAND",
        simulatorSubtitle: "Simulieren Sie die verbleibenden Rennen der Saison 2026. Wählen Sie die Zielpositionen aus, um die Wertungen in Echtzeit zu aktualisieren.",
        lockedGP: "Echte Ergebnisse (Gesperrt)",
        pendingGP: "Simulation Ausstehend",
        sprintResultsTitle: "Sprint-Ergebnisse (Top 8)",
        raceResultsTitle: "Rennergebnisse (Top 10)",
        mathematicalChamp: "🏆 MATHEMATISCHER WELTMEISTER!",
        resetAll: "Simulator Zurücksetzen",
        prefillRemaining: "Restliche Vorhersagen",
        clearGP: "GP Zurücksetzen",
        selectDriver: "Fahrer Auswählen"
    },
};

export const availableLanguages = [
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'zh', name: '中文', flag: '🇨🇳' },
    { code: 'ja', name: '日本語', flag: '🇯🇵' },
    { code: 'ar', name: 'العربية', flag: '🇸🇦' },
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'it', name: 'Italiano', flag: '🇮🇹' },
    { code: 'nl', name: 'Nederlands', flag: '🇳🇱' },
    { code: 'hu', name: 'Magyar', flag: '🇭🇺' },
    { code: 'pt', name: 'Português', flag: '🇵🇹' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' }
];
